import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/arrow.svg'
import _imports_1 from '../../assets/share-white.png'
import _imports_2 from '../../assets/share-blue.png'
import _imports_3 from '../../assets/gps.png'
import _imports_4 from '../../assets/map2.png'


const _hoisted_1 = { class: "bus-stop-info" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "action-section__bus-number" }
const _hoisted_4 = { class: "info-section" }
const _hoisted_5 = { class: "info-section__name" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Share"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 分享頁面 ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Share"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 分享頁面 ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "gps"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 前往導航 ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "stop-map-section" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "站牌位置", -1)
const _hoisted_17 = { class: "map__container" }
const _hoisted_18 = { class: "map" }
const _hoisted_19 = { class: "route-list" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "站牌公車", -1)
const _hoisted_21 = { class: "route-list__container" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "bus-map-gps" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 站牌地圖 ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 前往導航 ")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_HeaderBar = _resolveComponent("HeaderBar")!
  const _component_StopMap = _resolveComponent("StopMap")!
  const _component_BusInfoCard = _resolveComponent("BusInfoCard")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!
  const _component_BusStopMapDialog = _resolveComponent("BusStopMapDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_component_BaseLayout, null, {
      header: _withCtx(() => [
        _createVNode(_component_HeaderBar)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("section", {
            class: "action-section",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentCityZhtw) + "｜" + _toDisplayString(_ctx.stopName), 1)
          ]),
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.stopName), 1),
            _createElementVNode("div", {
              class: "info-section__share-button button mobile",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sharePageInfo && _ctx.sharePageInfo(...args)))
            }, _hoisted_8),
            _createElementVNode("div", {
              class: "info-section__share-button button pc",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sharePageInfo && _ctx.sharePageInfo(...args)))
            }, _hoisted_11),
            _createElementVNode("div", {
              class: "info-section__gps button pc",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goUseGps && _ctx.goUseGps(...args)))
            }, _hoisted_14)
          ]),
          _createElementVNode("section", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_StopMap, { currentBusStopPostion: _ctx.currentBusStopPostion }, null, 8, ["currentBusStopPostion"])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("article", _hoisted_21, [
              (_ctx.busRoutes.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentBusStopAllRoutesInfo, (routeInfo) => {
                    return (_openBlock(), _createBlock(_component_BusInfoCard, {
                      key: routeInfo.RouteUID,
                      routeInfo: routeInfo,
                      onClick: ($event: any) => (_ctx.findBusRoute(routeInfo.RouteName?.Zh_tw))
                    }, null, 8, ["routeInfo", "onClick"]))
                  }), 128))
                : (_openBlock(), _createElementBlock("p", _hoisted_22, "未查詢到相關公車路線！"))
            ])
          ]),
          _createElementVNode("section", _hoisted_23, [
            _createElementVNode("div", {
              class: "bus-map-gps__map-button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowStopMap = true))
            }, _hoisted_26),
            _createElementVNode("div", {
              class: "bus-map-gps__gps-button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goUseGps && _ctx.goUseGps(...args)))
            }, _hoisted_29)
          ])
        ])
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isShowStopMap)
        ? (_openBlock(), _createBlock(_component_BusStopMapDialog, {
            key: 0,
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowStopMap = false)),
            currentBusStopPostion: _ctx.currentBusStopPostion
          }, null, 8, ["currentBusStopPostion"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}